import { render, staticRenderFns } from "./CollegeCardPanel.vue?vue&type=template&id=6b8e383c"
import script from "./CollegeCardPanel.vue?vue&type=script&lang=js"
export * from "./CollegeCardPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports